import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// Tokens first: everything after them reads the variables they define.
// Self-hosted, not from a font CDN: a mail product does not tell a third
// party who is reading their mail, or when.
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles/tokens.css';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
